import { useCreateSubGoalAllowed } from 'features/goals';
import { useCallback } from 'react';
import { useOpenCreateGoalDialog } from 'shared/contexts/goal-form';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { Goal } from 'shared/types/goal';

export const useAddSubGoal = (goal?: Goal) => {
  const openCreateGoalDialog = useOpenCreateGoalDialog();
  const openPremiumDialog = useOpenPremiumDialog();
  const { allowed } = useCreateSubGoalAllowed();

  const onAddSubGoal = useCallback(() => {
    if (!goal) {
      return;
    }
    if (!allowed) {
      openPremiumDialog();
      return;
    }

    openCreateGoalDialog({ parentIds: [goal.id] });
  }, [goal, allowed, openCreateGoalDialog, openPremiumDialog]);

  return { onAddSubGoal };
};
